import React from 'react'
import { D101_0, D102_1, D151_0, P151_1, P152_1, P155_1_RATE } from 'rpqs/constants/RpqsConstant'
import PropTypes from 'prop-types'
import DialogD102_1 from './DialogD102_1'
import DialogD101_0 from './DialogD101_0'
import DialogP155_1 from './DialogP155_1'
import DialogP152_1 from './DialogP152_1'
import DialogD151_0 from './DialogD151_0'
import DialogP151_1 from './DialogP151_1'

const SubscriberDialog = ({
    open = false,
    setOpen = () => {},
    codeIndicator = '',
    dialogTitle = '',
}) => {
    return (
        <>

            {codeIndicator === D102_1.code &&
                <DialogD102_1
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === D101_0.code &&
                <DialogD101_0
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P155_1_RATE.code &&
                <DialogP155_1
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P152_1.code &&
                <DialogP152_1
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === D151_0.code &&
                <DialogD151_0
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P151_1.code &&
                <DialogP151_1
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
        </>
    )
}

SubscriberDialog.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    codeIndicator: PropTypes.string,
    dialogTitle: PropTypes.string,
}

export default SubscriberDialog